import {Component} from '@angular/core';

import {Platform} from '@ionic/angular';
import {SplashScreen} from '@capacitor/splash-screen';
import {StatusBar, Style} from '@capacitor/status-bar';
import {Capacitor} from '@capacitor/core';
import {FirebaseService} from './@shared/services/firebase.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss']
})
export class AppComponent {
    constructor(
        private platform: Platform,
        // private fireSrv: FirebaseService
    ) {
        this.initializeApp();
    }

    initializeApp() {
        this.platform.ready().then(() => {
            // Verificar se está rodando em plataforma nativa (não web)
            if (Capacitor.isNativePlatform()) {
                StatusBar.setStyle({ style: Style.Default });
                SplashScreen.hide();
            }
            // this.fireSrv.init();
        });
    }
}
